import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAdminPermissions } from '../lib/permissions';

/*
 * İki ya da daha fazla eski ekranı tek menü maddesinde
 * toplayan sayfa (Footer = Menü + Sayfalar, Alan Adları = Sabit adresler +
 * Giriş adresleri). Ekranların kendisi değişmez; her biri kendi bileşeni ve
 * kendi izniyle çizilir. Açık sekme adreste durur (`?sekme=`), bağlantı ve
 * yer imi doğru sekmeyi açar.
 */
const MergedTabsPage = ({ tabs, label }) => {
  const { can } = useAdminPermissions();
  const [params, setParams] = useSearchParams();
  const visible = tabs.filter((item) => !item.permission || can(item.permission));
  const current = visible.find((item) => item.id === params.get('sekme')) || visible[0];

  if (!current) return null;
  const Component = current.component;

  return (
    <div className="v2-merged">
      {visible.length > 1 && (
        <nav className="v2-subtabs" aria-label={label}>
          {visible.map((item) => (
            <button
              key={item.id}
              type="button"
              className={`v2-subtab ${item.id === current.id ? 'is-active' : ''}`}
              aria-current={item.id === current.id ? 'page' : undefined}
              onClick={() => setParams({ sekme: item.id }, { replace: true })}
            >
              {item.icon && <item.icon size={15} aria-hidden="true" />}
              {item.label}
            </button>
          ))}
        </nav>
      )}
      <Component key={current.id} />
    </div>
  );
};

export default MergedTabsPage;
